export const AVATAR_VIDEO_CSS = /* css */ `
  .lk-widget-avatar-video {
    position: relative;
    width: 100%;
    height: 100%;
    background: #000;
    overflow: hidden;
  }
  .lk-widget-avatar-video video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .lk-widget-avatar-video-close {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lk-widget-avatar-video-close:hover {
    background: rgba(0, 0, 0, 0.7);
  }
`;
